import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import cx from 'classnames';
import moment from 'moment';

import AppointmentHistory from './AppointmentHistory';
import ProfileInfo from './ProfileInfo';
import ProfileWithoutClient from './ProfileWithoutClient';
import MemberShip from './MemberShip';
import Notes from './Notes';
import Loading from '../../common/Loading';

import './index.scss';

const getClientDetailsById = (list, id) => {
  if (list.length > 0 && !id) {
    id = list[0].id;
  }
  return list.find((item) => item.id === id) || {};
};

const focusOut = () => {
  document.getElementById('focusout').focus();
};

const getOptionLabel = (option) => (
  <span className="option-text">
    <i className="material-icons">account_circle</i>
    {option.name}
  </span>
);

const ClientProfile = ({
  clients,
  appointments,
  businessId,
  getClientAppointments,
  selectedConversation,
  conversations,
  auth,
  typeofUser,
  showPaymntinfo,
  editCallerName,
}) => {
  const selectedClientId = clients && clients.length ? clients[0].id : null;
  const [selectedClient, setClient] = useState(selectedClientId);

  useEffect(() => {
    if (selectedClientId) {
      setClient(selectedClientId);
    }
  }, [selectedClientId]);

  useEffect(() => {
    if (selectedClient) {
      getClientAppointments({
        businessId,
        clientId: selectedClient,
        start: moment()
          .startOf('d')
          .subtract(3, 'months')
          .format('YYYY-MM-DDTHH:mm:ss'),
        end: moment().format('YYYY-MM-DDTHH:mm:ss'),
        domain: auth.domain,
      });
    }
  }, [selectedClient]);

  const clientInfo = getClientDetailsById(clients, selectedClient);
  const name = selectedConversation?.userName.trim() || typeofUser;
  const noClientId = { bzId: businessId, name };
  if (!selectedClientId && !conversations.getClientsDetails) {
    return (
      <>
        <ProfileWithoutClient
          details={noClientId}
          selectedConversation={selectedConversation}
          typeofUser={typeofUser}
          showPaymntinfo={showPaymntinfo}
          editCallerName={editCallerName}
        />
        <div className="client-profile--blank-state">
          <div className="client-profile__blank-container">
            <i className="material-icons">account_circle</i>
            <p className="client-profile__blank-container__title">
              No <span> </span>
              {typeofUser} <span> </span>
              profile available
            </p>
          </div>
        </div>
      </>
    );
  }

  return (
    <div
      className={cx('client-profile', {
        'client-profile-loader': conversations.getClientsDetails,
      })}
    >
      {conversations.getClientsDetails ? (
        <Loading style={{ display: 'flex', margin: '0 auto' }} />
      ) : (
        <div className="client-profile__dropdown">
          {clients.length === 1 ? null : (
            <Select
              value={clients.filter((option) => option.id === selectedClient)}
              getOptionLabel={getOptionLabel}
              getOptionValue={(option) => option.id}
              options={clients}
              onChange={(client) => {
                setClient(client.id);
                focusOut();
              }}
              className="client-dropdown"
              classNamePrefix="client-dropdown"
            />
          )}
        </div>
      )}
      <div tabindex="-1" id="focusout"></div>
      {!conversations.getClientsDetails && (
        <ProfileInfo
          details={clientInfo}
          selectedConversation={selectedConversation}
          typeofUser={typeofUser}
          showPaymntinfo={showPaymntinfo}
          editCallerName={editCallerName}
        />
      )}
      {!conversations.getClientsDetails &&
        clientInfo &&
        clientInfo.pricing &&
        clientInfo.pricing.length > 0 && <MemberShip details={clientInfo} />}
      {!conversations.getClientsDetails && clientInfo && clientInfo.notes ? (
        <Notes notes={clientInfo.notes} />
      ) : null}

      {!conversations.getClientsDetails &&
        selectedClient &&
        !conversations.getClientsAppointments &&
        appointments &&
        appointments.length ? (
          <AppointmentHistory appointments={appointments} auth={auth} />
        ) : null}
    </div>
  );
};

export default ClientProfile;
